"use client";

import { useURLSearchParams } from "@/app/hooks/useURLSearchParams";

// 参数配置类型
interface ParamConfig {
  [key: string]: {
    defaultValue: string | number | boolean;
    type?: "string" | "number" | "boolean";
  };
}

/**
 * 自定义 Hook，用于获取和处理动态查询参数
 * @param config 参数配置对象
 * @returns 参数对象
 */
export function useQueryParams<T extends ParamConfig>(
  config: T,
): {
  [K in keyof T]: string | number | boolean;
} {
  const searchParams = useURLSearchParams();

  const params = {} as { [K in keyof T]: string | number | boolean };

  for (const [key, { defaultValue, type = "string" }] of Object.entries(
    config,
  )) {
    const value = searchParams?.get(key) ?? null;

    if (value === null) {
      params[key as keyof T] = defaultValue;
      continue;
    }
    // 处理不同类型的参数
    switch (type) {
      case "number":
        params[key as keyof T] = parseInt(value, 10) || defaultValue;
        break;
      case "boolean":
        params[key as keyof T] = value === "true" || defaultValue;
        break;
      case "string":
      default:
        params[key as keyof T] = value || defaultValue;
        break;
    }
  }

  return params;
}
